import {StateUtils} from '@spartacus/core';
import {InvoiceHistoryList} from '../../../invoices.model';


export const INVOICES = '[Invoices] Invoices';
export const LOAD_INVOICES = '[Invoices] Load Invoices';
export const LOAD_INVOICES_SUCCESS = '[Invoices] Load Invoices Success';
export const LOAD_INVOICES_FAIL = '[Invoices] Load Invoices Fail';
export const LOAD_INVOICES_RESET = '[Invoices] Load Invoices Reset';

export class LoadInvoices extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_INVOICES;

  constructor(public payload: any) {
    super(INVOICES);
  }
}

export class LoadInvoicesSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_INVOICES_SUCCESS;

  constructor(public payload: InvoiceHistoryList) {
    super(INVOICES);
  }
}

export class LoadInvoicesFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_INVOICES_FAIL;

  constructor(public payload: any) {
    super(INVOICES, payload);
  }
}

export class LoadInvoiceReset extends StateUtils.LoaderResetAction {
  readonly type = LOAD_INVOICES_RESET;

  constructor(public payload: any) {
    super(INVOICES);
  }
}


export type CustomInvoicesHistoryActions =
  LoadInvoices
  | LoadInvoicesSuccess
  | LoadInvoicesFail
  | LoadInvoiceReset;
